'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconPause = function IconPause(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm8.93203125 21h-3.4890625c-.24609375 0-.44296875-.2025-.44296875-.45v-17.1c0-.2475.196875-.45.44296875-.45h3.4890625c.24609375 0 .44296875.2025.44296875.45v17.1c0 .2475-.196875.45-.44296875.45zm9.62499995 0h-3.4890625c-.2460937 0-.4429687-.2025-.4429687-.45v-17.1c0-.2475.196875-.45.4429687-.45h3.4890625c.2460938 0 .4429688.2025.4429688.45v17.1c0 .2475-.196875.45-.4429688.45z', fill: color })
  );
};

IconPause.propTypes = {
  color: _propTypes2.default.string
};

IconPause.defaultProps = {
  color: _colors2.default.icons
};

IconPause.displayName = 'IconPause';

exports.default = IconPause;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/icons/icon-pause.js
// module id = 816
// module chunks = 0